import mapLanguageToTemplate from './mapLanguageToTemplate';

/**
 * Returns a callback that maps available language options in results
 * to the language select component.
 * @param {Element} component
 * @param {Element[]} results
 * @param {jQuery} $itemTemplate
 * @return {Function} A callback function
 */
const handleLanguages = (component, results, $itemTemplate) => () => {
    const $list = $(component).find('.downloads-list__lang .select__list');

    const availableLangs = Object.keys(results.reduce((obj, entry) => {
        const langs = $(entry).attr('data-lang')
            .split(',')
            .filter(str => str);
        $(langs).each((_, lang) => {
            obj = { ...obj, [lang]: true };
        });
        return obj;
    }, {}));
    const items = mapLanguageToTemplate(availableLangs, $itemTemplate);

    $list.empty().append(items);
};

export default handleLanguages;



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/handleLanguages.js